export default __webpack_public_path__ + "static/media/UntitledSans-Bold.a66b0ce3.woff2";